import {Route, Switch} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import {getPageIndex} from 'src/EstateFlowchart/components/FormNav/FormNavUtils';
import {NavItem} from 'src/EstateFlowchart/components/FormNav/NavItem';
import FormPages from 'src/EstateFlowchart/config/FormPages';
import {
    Beneficiaries,
    Distribution,
    DistributionType,
    EstateItemTypes
} from 'src/EstateFlowchart/model/EstateFlowchartTypes';
import {IrrevocableTrust} from 'src/EstateFlowchart/model/IrrevocableTrust';
import BasicInformationContent from 'src/EstateFlowchart/pages/BasicInformation/BasicInformationContent';
import BeneficiariesFirstDeathContent from "../../pages/BeneficiariesAtFirstDeath/BeneficiariesFirstDeathContent";
import {getFamilyMemberByMemberId} from "../../utils/DefUtils";
import {useAppSelector} from "../../../store/hooks";
import {familyMembersSelector} from "../../slices/EstateFlowChartSlice";
import {selectReleaseToggles} from "../../../ReleaseToggles/releaseTogglesSlice";

type IrrevocableTrustContentProps = {
    irrevocableTrust: IrrevocableTrust;
    pageConfig: NavItem[];
    updateIrrevocableTrust: (irrevTrust: IrrevocableTrust) => void;
    saveForm: () => Promise<boolean>;
}

function IrrevocableTrustContent({
                                     irrevocableTrust,
                                     updateIrrevocableTrust,
                                     pageConfig,
                                     saveForm
                                 }: Readonly<IrrevocableTrustContentProps>): JSX.Element {
    const rawFamilyMembers = useAppSelector(familyMembersSelector);
    const [firstDeathTerminationMemberName, setFirstDeathTerminationMemberName] = useState<string>();
    const releaseToggles = useAppSelector(selectReleaseToggles);

    useEffect(() => {
        let familyMember: any = getFamilyMemberByMemberId(irrevocableTrust.firstDeathTerminationMember?.memberId, rawFamilyMembers);
        if (!familyMember && releaseToggles?.enableEstateFlowchartMVPRelease) {
            familyMember = {firstName: "", lastName: irrevocableTrust.firstDeathTerminationMember?.customName};
        }
        setFirstDeathTerminationMemberName(familyMember?.firstName + ' ' + familyMember?.lastName);
    }, [irrevocableTrust.firstDeathTerminationMember, releaseToggles?.enableEstateFlowchartMVPRelease]);

    return (
        <Switch>
            <Route
                path="/Profile/:id/ClientProfile/EstateFlowchart/:flowchartId/IrrevocableTrust/:trustId/BasicInformation">
                <BasicInformationContent
                    basicInformation={irrevocableTrust}
                    updateEstateItem={(estateItem: EstateItemTypes) => {
                        updateIrrevocableTrust(estateItem as IrrevocableTrust);
                    }}
                    pageIndex={getPageIndex(pageConfig, FormPages.BASIC_INFORMATION.id)}
                />
            </Route>
            <Route
                path="/Profile/:id/ClientProfile/EstateFlowchart/:flowchartId/IrrevocableTrust/:trustId/BeneficiariesAtFirstDeath">
                <BeneficiariesFirstDeathContent
                    distributions={irrevocableTrust?.firstDeathBeneficiaries?.firstDeathDistributions ?? []}
                    updateEstateItem={(firstDeathDistributions: Distribution[]) => {
                        updateIrrevocableTrust({
                            ...irrevocableTrust,
                            firstDeathBeneficiaries: {
                                // ...irrevocableTrust.beneficiaries,
                                firstDeathDistributions: firstDeathDistributions
                            } as Beneficiaries
                        });
                    }}
                    distributionDropdownOptionTypes={[DistributionType.IN_TRUST, DistributionType.CHARITY, DistributionType.OUTRIGHT]}
                    saveForm={saveForm}
                    pageIndex={getPageIndex(pageConfig, FormPages.BENEFICIARIES_AT_FIRST_DEATH.id)}
                    firstDeathMemberName={firstDeathTerminationMemberName}
                />
            </Route>
        </Switch>

    )
}

export default IrrevocableTrustContent